import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button, Modal } from 'src/components';
import headerImgSrc from './images/modal-image.png';
import * as S from './styles';

const msgs = defineMessages({
  title: {
    id: 'learning_session_repetition_popup_title',
    defaultMessage: 'Repetition makes perfect',
  },
  description: {
    id: 'learning_session_repetition_popup_bodycopy',
    defaultMessage:
      'In these lessons you may practice words you’ve already covered, but with new exercises to strengthen your memory.',
  },
  ok: {
    id: 'learnq_messaging_existing_users_CTA',
  },
});

export const RepeatedWordsModal: FC<{ isOpen: boolean; onClose: () => void }> = ({
  isOpen,
  onClose,
}) => {
  const intl = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      handleClose={onClose}
      shouldCloseOnEsc
      darkCloseIcon
      data-testid="repeated-words-modal"
    >
      <S.ModalContent>
        <div>
          <S.HeaderImage src={headerImgSrc} alt="" />
          <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
        </div>
        <S.Description>{intl.formatMessage(msgs.description)}</S.Description>
        <S.ActionButton>
          <Button
            buttonType="primary"
            buttonSize="large"
            wide
            onClick={onClose}
            data-testid="repeated-words-modal-ok-button"
          >
            {intl.formatMessage(msgs.ok)}
          </Button>
        </S.ActionButton>
      </S.ModalContent>
    </Modal>
  );
};

export default RepeatedWordsModal;
